import React from "react";
import { ChevronLeft } from "lucide-react";

export interface ModalHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  toggle?: () => void;
  showBack?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ toggle, showBack = false, children, className = '', ...props }) => {
  return (
    <div className={`flex items-center justify-between px-4 py-3 border-b border-gray-200 ${className || ''}`} {...props}>
      <div className="flex items-center gap-2">
        {showBack && toggle && (
          <button
            onClick={toggle}
            className="flex items-center justify-center w-8 h-8 rounded-full text-gray-700 cursor-pointer"
            aria-label="Back"
          >
            <ChevronLeft size={18} />
          </button> 
        )}
        <div className="text-lg font-semibold">{children}</div>
      </div>
      {toggle && !showBack && (
        <button onClick={toggle} className="text-gray-700 hover:text-(--color-primary)">
          ✕
        </button>
      )}
    </div>
  );
};
